import { useQuery } from '@tanstack/react-query';
import { getRoundStatus } from '../services/round.service';

interface UseRoundStatusOptions {
    /** Skip the fetch entirely. Defaults to `true`. */
    enabled?: boolean;
}

/**
 * The round's public state. One shared query key and polling interval, so the
 * round banner and the tutorial read and refresh the SAME cache entry.
 */
export function useRoundStatus({ enabled = true }: UseRoundStatusOptions = {}) {
    return useQuery({
        queryKey: ['round', 'status'],
        queryFn: getRoundStatus,
        staleTime: 30_000,
        refetchInterval: 60_000,
        enabled,
    });
}
